@if(user.id !== ""){
<div class="contentMain">
  <div id="id">ID: {{ user.id }}</div>
  {{ user.firstname }} {{ user.lastname }}
  <a class="btn" (click)="logout()">🔒Logout</a>
</div>
}
